<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Print_Body__And__Centre_Alignment__And__Line_Spacing"><span><span class="C_Current__And__Coloured_Text__And__Georgia__And__Italic">To Dwight E. Neuenschwander, CE Walker, and Alan Marcus.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?fcd11498